export function parseEventPath(path) {
  // Remove any leading/trailing slashes
  const cleanPath = path.replace(/^\/+|\/+$/g, '');

  // Split the path into components
  const parts = cleanPath.split('/');

  // Check if path matches expected format: {slug}/e/{event_name}
  if (parts.length >= 3 && parts[1] === 'e') {
    return {
      slug: parts[0],
      eventSlug: parts[2],
    };
  }

  return null;
}
